<app-header></app-header>
<div class="container">
  <div class="row justify-content-start">
    <div class="col-sm-5">
      <h2>Sesión Grupal</h2>
    </div>
    <div class="col-3">
      Asistió a la sesión
      <label class="chbx-container chbx-purple">
        <input
          type="checkbox"
          (change)="toggleHabilitado($event.target)"
          id="segr_asistio"
          [defaultChecked]="true"
        />
        <div class="checkmark"></div>
      </label>
    </div>
    <div class="col-sm-2 offset-sm-1 text-end">
      <button class="btn btn-color2" (click)="volverAGrupo()">Volver</button>
    </div>
  </div>
  <form>
    <div class="row justify-content-center">
      <div class="col-6 col-md-2 mt-2">
        <label for="fecha_sesion" class="form-label">Fecha de sesión</label>
        <div class="input-group">
          <input
            class="form-control"
            [ngClass]="{ 'is-invalid': c.invalid && c.touched }"
            placeholder="dd/mm/yyyy"
            name="fecha_sesion"
            [displayMonths]="2"
            #c="ngModel"
            [(ngModel)]="fecha_sesion"
            ngbDatepicker
            [footerTemplate]="footerTemplate"
            #d="ngbDatepicker"
          />
          <button
            class="btn btn-outline-secondary"
            (click)="d.toggle()"
            type="button"
          >
            <fa-icon [icon]="icon1"></fa-icon>
          </button>
        </div>
        <!-- <pre>Model: {{ fecha_sesion | json }}</pre> -->
      </div>
      <div class="col-6 col-md-2 mt-2">
        <label for="hora_sesion" class="form-label">Hora de sesión</label>
        <ngb-timepicker
          [(ngModel)]="hora_sesion"
          [meridian]="true"
          [spinners]="false"
          name="hora_sesion"
        />
        <!-- <pre>Selected time: {{ hora_sesion | json }}</pre> -->
      </div>
      <div class="col-md-2 mt-2">
        <label for="numero_sesion" class="form-label">Número de sesión</label>
        <input
          type="text"
          class="form-control"
          id="numero_sesion"
          disabled
          value="{{ sesionGrupal.numero_sesion }}"
        />
      </div>
      <!-- <div class="col-md-4">
          <label for="segr_proxima_sesion" class="form-label"
          >Proxima sesión</label
          >
          <input
          type="datetime-local"
          class="form-control"
          id="segr_proxima_sesion"
          (change)="handleChange($event.target)"
          value="{{ sesionGrupal.segr_proxima_sesion }}"
          />
        </div> -->
      <div class="col-2 mt-2">
        <label class="chbx-container form-label">
          Hay próxima sesión
          <input
            type="checkbox"
            (change)="toggleHabilitado($event.target)"
            id="segr_sesiones_aplica"
            [defaultChecked]="true"
          />
          <div class="checkmark"></div>
        </label>
      </div>
      <div class="col-6 col-md-2 mt-2">
        <label for="fecha_proxima_sesion" class="form-label"
          >Fecha próxima sesión</label
        >
        <div class="input-group">
          <input
            class="form-control"
            [ngClass]="{ 'is-invalid': c2.invalid && c2.touched }"
            placeholder="dd/mm/yyyy"
            name="fecha_proxima_sesion"
            [displayMonths]="2"
            #c2="ngModel"
            [(ngModel)]="fecha_proxima_sesion"
            ngbDatepicker
            [footerTemplate]="footerTemplate"
            #d2="ngbDatepicker"
            [disabled]="
              sesionGrupal.segr_sesiones_aplica === '0' ? true : false
            "
          />
          <button
            class="btn btn-outline-secondary"
            (click)="d2.toggle()"
            type="button"
          >
            <fa-icon [icon]="icon1"></fa-icon>
          </button>
        </div>
        <!-- <pre>Model: {{ fecha_sesion | json }}</pre> -->
      </div>
      <div class="col-6 col-md-2 mt-2">
        <label for="hora_proxima_sesion" class="form-label"
          >Hora próxima sesión</label
        >
        <ngb-timepicker
          [(ngModel)]="hora_proxima_sesion"
          [meridian]="true"
          [spinners]="false"
          name="hora_proxima_sesion"
          [disabled]="sesionGrupal.segr_sesiones_aplica === '0' ? true : false"
        />
        <!-- <pre>Selected time: {{ hora_sesion | json }}</pre> -->
      </div>
      <div class="col-md-4 mt-2">
        <label for="carrera" class="form-label">Carrera</label>
        <input
          type="text"
          class="form-control"
          id="carrera"
          placeholder="Carrera"
          disabled
          value="{{ sesionGrupal.carrera }}"
        />
      </div>
      <div class="col-md-4 mt-2">
        <label for="grupo" class="form-label">Grupo</label>
        <input
          type="text"
          class="form-control"
          id="grupo"
          placeholder="Grupo"
          disabled
          value="{{ sesionGrupal.grupo }}"
        />
      </div>
      <div class="col-md-4 mt-2">
        <label for="responsable" class="form-label"
          >Nombre del responsable</label
        >
        <input
          type="text"
          class="form-control"
          id="responsable"
          placeholder="Nombre del responsable"
          disabled
          value="{{ sesionGrupal.responsable }}"
        />
      </div>
      <div class="col-12">
        <label for="segr_tema">Tipo de tema</label>
        <ng-select
          [multiple]="true"
          [(ngModel)]="selectedItems"
          [items]="temas"
          bindLabel="nombre"
          bindValue="nombre"
          name="segr_tema"
          id="segr_tema"
        ></ng-select>
      </div>
      <div class="col-12 mt-2">
        <label for="segr_aspectos_trabajados" class="form-label"
          >Temas abordados</label
        >
        <textarea
          type="text"
          class="form-control"
          id="segr_aspectos_trabajados"
          value="{{ sesionGrupal.segr_aspectos_trabajados }}"
          (change)="handleChange($event.target)"
          placeholder="Ingresar el tema abordado"
        ></textarea>
      </div>
      <div class="col-12 mt-2">
        <label for="segr_faltantes" class="form-label"
          >Nombre de los alumnos que no asistieron</label
        >
        <textarea
          type="text"
          class="form-control"
          id="segr_faltantes"
          value="{{ sesionGrupal.segr_faltantes }}"
          (change)="handleChange($event.target)"
          placeholder="Ingresar el nombre de los alumnos faltantes..."
        ></textarea>
      </div>
      <div class="col-md-6 mt-2">
        <label for="segr_participantes" class="form-label"
          >Número de alumnos participantes</label
        >
        <input
          type="number"
          class="form-control"
          id="segr_participantes"
          placeholder="4"
          value="{{ +sesionGrupal.segr_participantes }}"
          (change)="handleChange($event.target)"
        />
      </div>
      <div class="col-md-6 mt-2">
        <label for="segr_notas" class="form-label">Notas adicionales</label>
        <textarea
          type="text"
          class="form-control"
          id="segr_notas"
          placeholder="Notas adicionales"
          value="{{ sesionGrupal.segr_notas }}"
          (change)="handleChange($event.target)"
        ></textarea>
      </div>
      <div class="col-md-6 mt-2">
        <label for="segr_solicitador" class="form-label">Solicitador</label>
        <select
          class="form-select"
          id="segr_solicitador"
          aria-label="Default select example"
          value="{{ sesionGrupal.segr_solicitador }}"
          (change)="handleChange($event.target)"
        >
          <option value="" selected>Selecciona el tipo de Solicitador</option>
          <option value="1">Alumno</option>
          <option value="2">Docente</option>
          <option value="3">Personal</option>
          <option value="4">Tutor</option>
          <option value="5">Otro</option>
        </select>
      </div>
      <div class="col-md-6 mt-2" *ngIf="!sesionGrupal.segr_solicitador"></div>
      <div
        class="col-md-6"
        *ngIf="
          sesionGrupal.segr_solicitador == '2' ||
          sesionGrupal.segr_solicitador == '3'
        "
      >
        <label for="segr_cve_personal" class="form-label">Personal</label>
        <select
          class="form-select"
          id="segr_cve_personal"
          value="{{ sesionGrupal.segr_cve_personal }}"
          *ngIf="personal.length"
          (change)="handleChange($event.target)"
        >
          <option
            *ngFor="let persona of personal"
            [value]="persona.clave"
            [attr.selected]="
              sesionGrupal.segr_cve_personal == persona.clave ? true : null
            "
          >
            {{ persona.nombre }}
          </option>
        </select>
      </div>
      <div
        class="col-md-6 mt-2"
        *ngIf="
          sesionGrupal.segr_solicitador == '1' ||
          sesionGrupal.segr_solicitador == '4' ||
          sesionGrupal.segr_solicitador == '5'
        "
      >
        <label for="segr_nombre_solicitador" class="form-label"
          >Nombre del solicitador</label
        >
        <input
          type="text"
          class="form-control"
          id="segr_nombre_solicitador"
          placeholder="Nombre del solicitador"
          [value]="
            sesionGrupal.segr_solicitador == '4'
              ? sesionGrupal.responsable
              : sesionGrupal.segr_nombre_solicitador
          "
          [disabled]="sesionGrupal.segr_solicitador == '4'"
          (change)="handleChange($event.target)"
        />
      </div>
      <div class="col-md-6 mt-2">
        <label for="registradoPor" class="form-label">Registrado por</label>
        <input
          type="text"
          class="form-control"
          id="registradoPor"
          disabled
          value="{{ sesionGrupal.registrador }}"
        />
      </div>
      <div class="col-md-6 mt-2">
        <label for="segr_fecha_registro" class="form-label"
          >Fecha de registro</label
        >
        <input
          type="datetime-local"
          class="form-control"
          id="segr_fecha_registro"
          disabled
          value="{{ sesionGrupal.segr_fecha_registro }}"
        />
      </div>
      <div class="col-12 mt-3 text-center">
        <button class="btn btn-color1" (click)="registrarSesionGrupal()">
          Guardar
        </button>
      </div>
    </div>
  </form>
</div>

<ng-template #footerTemplate>
  <hr class="my-0" />
  <button
    class="btn btn-primary btn-sm m-2 float-start"
    (click)="fecha_sesion = today; d.close()"
    (click)="fecha_proxima_sesion = today; d2.close()"
  >
    Seleccionar Hoy
  </button>
</ng-template>
